import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Clickwrap from 'components/Clickwrap';
import {
  fetchWeddingsNotification,
  saveWeddingsNotification,
} from 'apollo/projects.query';

import APFormGroup from 'components/FormFields/APFormGroup';
import ProjectsSettingsReminders from './ProjectsSettings.Reminders';

import './styles.scss';

const categories = [
  {
    name: 'COMMENTS',
    prefs:[
      {
        name: 'On Tasks',
        key: 'comment.task',
      },
      {
        name: 'On Images',
        key: 'comment.style-guide-image',
      },
      {
        name: 'On Project Contacts',
        key: 'comment.vendor-file-area',
      },
    ],
  },
  {
    name: "Tasks I'm Assigned To",
    prefs: [
      {
        name: 'Assignment',
        key: 'task.assigned',
      },
      {
        name: 'Reminders',
        key: 'reminder.task',
      },
      {
        name: 'Completed (By Someone Else)',
        key: 'task.completed',
      },
    ],
  },
  {
    name: "Tasks I've Assigned Out",
    prefs: [
        {
          name: 'Reminders',
          key: 'reminder.task.involved',
        },
        {
          name: 'Completed',
          key: 'task.completed.involved',
        },
      ],
  },
  {
    name: 'All Project Tasks',
    prefs: [
      {
        name: 'Reminders',
        key: 'reminder.task.broadcast',
      },
      {
        name: 'Completed',
        key: 'task.completed.broadcast',
      },
    ],
  },
  {
    name: 'This Project',
    prefs: [
      {
        name: 'Planning Partner Added',
        key: 'wedding.partner-added',
      },
      {
        name: 'Payment Reminder',
        key: 'reminder.wedding-vendor-payment',
      },
    ],
  },
];

const ProjectsSettingsNotifications = ({ id, pushNotification }) => {
  const [weddingsNotification, setWeddingsNotification] = useState({});
  const weddingsId = id;

  const getFetchWeddingsNotification = async (weddingId) => {
    const items = await fetchWeddingsNotification(weddingId);
    setWeddingsNotification(items.weddingsNotification.prefs);
  };

  useEffect(() => {
    getFetchWeddingsNotification(weddingsId);
  },[]);

  const onChangeClickwrap = (event, notificationType) => {
    const getCommand = async (notification) => {
      const data = await saveWeddingsNotification(notification, weddingsId);
      if (data && pushNotification) {
        pushNotification({
          message: 'Project setting was automatically saved.',
          time: 3000,
        });
      }
    };

    const notification ={ ...weddingsNotification };
    if(notificationType === 'email'){
      notification[event] = {
        email: !notification[event].email,
        notify: notification[event].notify };
    }else if(notificationType === 'notify'){
      if(notification[event].notify){
        notification[event] = {
          email: false,
          notify: false };
      } else{
        notification[event] = {
          email: notification[event].email,
          notify: !notification[event].notify };
      }
    }
    setWeddingsNotification(notification);
    getCommand(notification);
  };

  const renderCategory = (index, category) => {
    return (
      <div
        key={`category-${index}`}
        className="settings-grid__group"
      >
        <div className="settings-grid__category">
          {category.name}
        </div>
        {category.prefs.map((pref) => renderRow(pref))}
      </div>
    );
  };

  const renderRow = (pref) => {
    const row = weddingsNotification[pref.key];
    return (
      <div
        key={pref.key}
        className="settings-grid__row"
      >
        <div className="settings-grid__cell">
          <p>
            {pref.name}
          </p>
        </div>
        <div className="settings-grid__cell">
          <Clickwrap
            name={`${pref.key}-notify`}
            checked={row?.notify}
            className="clickwrap--view-option small project_modal__features-checkbox"
            onChange={() => onChangeClickwrap(pref.key, 'notify')}
          />
        </div>
        <div className="settings-grid__cell">
          <Clickwrap
            name={`${pref.key}-email`}
            checked={row?.email}
            className="clickwrap--view-option small project_modal__features-checkbox"
            onChange={() => onChangeClickwrap(pref.key, 'email')}
          />
        </div>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <div className="project-notifications">
        <p className="project-notifications__intro">
          These notification settings control what notifications you receive for
          this project. Any updates you make won't change your default
          notification preferences in your user settings or your preferences in
          other projects.
        </p>
        <div className="project-notifications__notification-settings">
          <APFormGroup
            title="Notifications"
            grid={false}
          >
            <div className="settings-grid settings-grid--notifications">
              <div className='settings-grid__header'>
                <div className="settings-grid__row">
                  <div className="settings-grid__cell">
                    <h4 className="settings-grid__heading">Notification Type</h4>
                  </div>
                  <div className="settings-grid__cell center">
                    <h4 className="settings-grid__heading">In App</h4>
                  </div>
                  <div className="settings-grid__cell center">
                    <h4 className="settings-grid__heading">Email</h4>
                  </div>
                </div>
              </div>
              <div className="settings-grid__settings">
                {categories.map((category, index) => renderCategory(index, category))}
              </div>
            </div>
          </APFormGroup>
        </div>
        <div className="project-notifications__reminder-settings">
          <ProjectsSettingsReminders id={id}/>
        </div>
      </div>
    );
  };

  return renderForm();
};

ProjectsSettingsNotifications.propTypes = {
  id: PropTypes.number,
  pushNotification: PropTypes.func,
};

ProjectsSettingsNotifications.defaultProps = {};

export default ProjectsSettingsNotifications;
